import Container from '@modules/common/components/container';
import Stepper from '@modules/common/components/stepper';

/**
 * Skeleton component shown while checkout data is loading.
 */
export function CheckoutPageSkeleton() {
  const steps = ['購物車', '填寫購買資訊', '確認訂單'];

  return (
    <div className="relative">
      <Container className="mt-20 gap-x-40 pb-[120px]">
        <div className="grid w-full grid-cols-1 gap-y-8">
          {/* Stepper */}
          <div className="flex justify-center py-6">
            <Stepper steps={steps} activeStep={1} />
          </div>

          {/* Cart skeleton */}
          <div>
            <div className="flex items-center pb-3">
              <div className="bg-ui-bg-subtle h-6 w-48 animate-pulse rounded" />
            </div>
            <div className="pt-6">
              <div className="bg-white-20 border-white-40 rounded-md border p-6">
                {/* Line items skeleton */}
                <div className="space-y-4">
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="flex gap-4">
                      <div className="bg-ui-bg-subtle h-20 w-20 animate-pulse rounded-md" />
                      <div className="flex-1 space-y-2">
                        <div className="bg-ui-bg-subtle h-4 w-3/4 animate-pulse rounded" />
                        <div className="bg-ui-bg-subtle h-3 w-1/2 animate-pulse rounded" />
                        <div className="bg-ui-bg-subtle h-3 w-1/4 animate-pulse rounded" />
                      </div>
                      <div className="bg-ui-bg-subtle h-4 w-20 animate-pulse rounded" />
                    </div>
                  ))}
                </div>

                {/* Order summary skeleton */}
                <div className="mt-6 border-t pt-6">
                  <div className="space-y-3">
                    <div className="flex justify-between">
                      <div className="bg-ui-bg-subtle h-4 w-20 animate-pulse rounded" />
                      <div className="bg-ui-bg-subtle h-4 w-16 animate-pulse rounded" />
                    </div>
                    <div className="flex justify-between">
                      <div className="bg-ui-bg-subtle h-4 w-16 animate-pulse rounded" />
                      <div className="bg-ui-bg-subtle h-4 w-16 animate-pulse rounded" />
                    </div>
                    <div className="flex justify-between border-t pt-3">
                      <div className="bg-ui-bg-subtle h-5 w-24 animate-pulse rounded" />
                      <div className="bg-ui-bg-subtle h-5 w-20 animate-pulse rounded" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {/* Action bar skeleton */}
      <div className="bg-white-20 fixed bottom-0 w-full border-t pb-6 pt-4">
        <Container>
          <div className="flex items-center justify-between">
            <div className="bg-ui-bg-subtle h-10 w-32 animate-pulse rounded-md" />
            <div className="flex items-center gap-4">
              <div className="bg-ui-bg-subtle h-4 w-24 animate-pulse rounded" />
              <div className="bg-ui-bg-subtle h-6 w-20 animate-pulse rounded" />
            </div>
            <div className="bg-ui-bg-subtle h-10 w-40 animate-pulse rounded-md" />
          </div>
        </Container>
      </div>
    </div>
  );
}
